// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__0B0zR","settingList":"styles_settingList__7umIW","switchAction":"styles_switchAction__-tzOd","listItem":"styles_listItem__U8VwM"};